/* eslint no-use-before-define: 0 */ // --> OFF
/* eslint no-var: 0 */ // --> OFF
/* eslint no-unused-vars: 0 */ // --> OFF
/* eslint default-case: 0 */ // --> OFF
'use strict';

Object.defineProperty(exports, '__esModule', {
    value: true
});

var _createClass = (function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ('value' in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
})();

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError('Cannot call a class as a function');
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return call && (typeof call === 'object' || typeof call === 'function') ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== 'function' && superClass !== null) {
        throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass);
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: { value: subClass, enumerable: false, writable: true, configurable: true }
    });
    if (superClass)
        Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : (subClass.__proto__ = superClass);
}

var Value = (function (_React$Component) {
    _inherits(Value, _React$Component);

    function Value(props) {
        _classCallCheck(this, Value);

        var _this = _possibleConstructorReturn(
            this,
            (Value.__proto__ || Object.getPrototypeOf(Value)).call(this, props)
        );

        _this.handleMouseDown = _this.handleMouseDown.bind(_this);
        _this.onRemove = _this.onRemove.bind(_this);
        _this.handleTouchEndRemove = _this.handleTouchEndRemove.bind(_this);
        _this.handleTouchMove = _this.handleTouchMove.bind(_this);
        _this.handleTouchStart = _this.handleTouchStart.bind(_this);
        return _this;
    }

    _createClass(Value, [
        {
            key: 'handleMouseDown',
            value: function handleMouseDown(event) {
                if (event.type === 'mousedown' && event.button !== 0) {
                    return;
                }
                if (this.props.onClick) {
                    event.stopPropagation();
                    this.props.onClick(this.props.value, event);
                    return;
                }
                if (this.props.value.href) {
                    event.stopPropagation();
                }
            }
        },
        {
            key: 'onRemove',
            value: function onRemove(event) {
                event.preventDefault();
                event.stopPropagation();
                this.props.onRemove(this.props.value);
            }
        },
        {
            key: 'handleTouchEndRemove',
            value: function handleTouchEndRemove(event) {
                // Check if the view is being dragged, In this case
                // we don't want to fire the click event (because the user only wants to scroll)
                if (this.dragging) return;

                // Fire the mouse events
                this.onRemove(event);
            }
        },
        {
            key: 'handleTouchMove',
            value: function handleTouchMove() {
                // Set a flag that the view is being dragged
                this.dragging = true;
            }
        },
        {
            key: 'handleTouchStart',
            value: function handleTouchStart() {
                // Set a flag that the view is not being dragged
                this.dragging = false;
            }
        },
        {
            key: 'renderRemoveIcon',
            value: function renderRemoveIcon() {
                if (this.props.disabled || !this.props.onRemove) return;
                return _react2.default.createElement(
                    'span',
                    {
                        className: 'Select-value-icon',
                        'aria-hidden': 'true',
                        onMouseDown: this.onRemove,
                        onTouchEnd: this.handleTouchEndRemove,
                        onTouchStart: this.handleTouchStart,
                        onTouchMove: this.handleTouchMove
                    },
                    '\xD7'
                );
            }
        },
        {
            key: 'renderLabel',
            value: function renderLabel() {
                var className = 'Select-value-label';
                return this.props.onClick || this.props.value.href
                    ? _react2.default.createElement(
                          'a',
                          {
                              className: className,
                              href: this.props.value.href,
                              target: this.props.value.target,
                              onMouseDown: this.handleMouseDown,
                              onTouchEnd: this.handleMouseDown
                          },
                          this.props.children
                      )
                    : _react2.default.createElement(
                          'span',
                          { className: className, role: 'option', 'aria-selected': 'true', id: this.props.id },
                          this.props.children
                      );
            }
        },
        {
            key: 'render',
            value: function render() {
                return _react2.default.createElement(
                    'div',
                    {
                        className: (0, _classnames2.default)(
                            'Select-value',
                            this.props.value.disabled ? 'Select-value-disabled' : '',
                            this.props.value.className
                        ),
                        style: this.props.value.style,
                        title: this.props.value.title
                    },
                    this.renderRemoveIcon(),
                    this.renderLabel()
                );
            }
        }
    ]);

    return Value;
})(_react2.default.Component);

Value.propTypes = {
    children: _propTypes2.default.node,
    disabled: _propTypes2.default.bool, // disabled prop passed to ReactSelect
    id: _propTypes2.default.string, // Unique id for the value - used for aria
    onClick: _propTypes2.default.func, // method to handle click on value label
    onRemove: _propTypes2.default.func, // method to handle removal of the value
    value: _propTypes2.default.object.isRequired // the option object for this value
};

exports.default = Value;
